import { render, staticRenderFns } from "./DocumentToolbar.vue?vue&type=template&id=416af26a&scoped=true&"
import script from "./DocumentToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentToolbar.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_toolbar.scss?vue&type=style&index=0&id=416af26a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416af26a",
  null
  
)

export default component.exports